<template>
  <div class="hour-content" :style="widthStyle">
    <img class="aqi-img" v-show="svg1" :src="svg1" style="height: 81px" />
    <div @click="clickScrollItem" class="aqi-item" :data-id="index" v-for="(item, index) in aqiHour" :key="index">
        <div :class="[index>aqiHour.length-4?'tip-last':'tip']" v-show="index==hourIndex" :style="itemStyle(index)">
            <span>{{item.tmp+'°'}}{{item.realDes}}{{item.text}}</span>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      scrollIndex: this.hourIndex,
      topList: [],
      nameList: [],
      svg1: ''
    }
  },
  props: {
    aqiHour: Object | Array,
    hourIndex: Number,
    r: Number | String
  },
  computed: {
    widthStyle() {
      return {
        width: this.aqiHour.length*58 + 'px'
      }
    },
    itemStyle() {
      return function(index) {
        return {
          backgroundColor: 'rgba(0,0,0,.3)',
          top: this.topList[index] + 'px'
        }
      }
    }
  },
  created() {
    var t = this;
    setTimeout(function() {
      if (t.aqiHour) {
        var e = t.getSVG(t.aqiHour), r = e.svg, n = e.topList, i = e.nameList, o = encodeURI(r).replace(/'/g, "%27").replace('#', '%23');
        t.topList = n;
        t.nameList = i;
        t.svg1 = o;
      }
    }, 300);
  },
  methods: {
    getSVG: function(t) {
        for (var e = -100, r = 100, n = [], i = 0; i < t.length; i++) {
            var o = Number(t[i].tmp);
            o > e && (e = o), r > o && (r = o), n.push({
                x: 58 + 116 * i,
                y: o
            });
        }
        for (var a = e === r ? 1 : e - r, s = 160 / (e - r + 2 * a), h = 0; h < n.length; h++) {
            var g = n[h];
            g.y = (g.y - r + a) * s;
        }
        this.genControlPoint(n);
        for (var l = "data:image/svg+xml,<svg width='" + 116 * t.length + "' height='160'  xmlns='http://www.w3.org/2000/svg'>", y = (this.genPath(n, "#def6fe"),
        this.genCircle(n, "#000000"), this.genLine(n, "#ffffff")), x = [], u = [], c = 0; c < t.length; c++) x.push((112 - n[c].y) / 2),
        t[c].hour && u.push(t[c].hour);
        return {
            topList: x,
            nameList: u,
            svg: "" + l + y + "</svg>"
        };
    },
    genCircle: function(t, e) {
      for (var r = [], n = 0; n < t.length; n++) {
        var i = t[n], o = i.x, a = i.y;
        r.push("<circle cx='" + o + "' cy='" + a + "' r='4' stroke-width='0' fill='" + e + "' />");
      }
      return r.join("");
    },
    genLine: function(t, e) {
      for (var r = "<path d='M0 " + t[0].y, n = "' stroke-width='2' fill='none' stroke='" + e + "'/>", i = "L" + t[0].x + " " + t[0].y, o = 1; o < t.length; o++) {
        var a = t[o - 1], s = a.A, h = a.B, g = t[o], l = g.x, y = g.y;
        i += " C" + s.x + " " + s.y + " " + h.x + " " + h.y + " " + l + " " + y;
      }
      var x = t[t.length - 1];
      return i += " L" + (x.x + 58) + " " + x.y, "" + r + i + n;
    },
    genPath: function(t, e) {
      for (var r = "Z' stroke-width='0' fill='" + e + "'/>", n = "L0 " + t[0].y + " L0 " + t[0].y, i = 1; i < t.length; i++) {
        var o = t[i - 1], a = o.A, s = o.B, h = t[i], g = h.x, l = h.y;
        n += " C" + a.x + " " + a.y + " " + s.x + " " + s.y + " " + g + " " + l;
      }
      var y = t[t.length - 1];
      return "<path d='M0 0 " + (n += " L" + (y.x + 58) + " " + y.y + " L" + (y.x + 58) + " 0") + r;
    },
    genControlPoint: function(t) {
      if (!(t.length < 2)) for (var e = 0; e < t.length - 1; e++) {
        var r = t[e], n = 0 === e ? {
            x: 0,
            y: r.y
        } : t[e - 1], i = t[e + 1], o = e === t.length - 2 ? {
            x: i.x + 58,
            y: i.y
        } : t[e + 2], a = r.x + .25 * (i.x - n.x), s = r.y + .25 * (i.y - n.y), h = i.x - .25 * (o.x - r.x), g = i.y - .25 * (o.y - r.y);
        r.A = {
            x: a,
            y: s
        }, r.B = {
            x: h,
            y: g
        };
      }
    },
    clickScrollItem: function(t) {
      var e = t.currentTarget.dataset.id;
      this.scrollIndex = e;
    }
  }
}
</script>
<style lang="stylus" scoped>
.aqi-img {
  transform: scaleY(-1);
  position: absolute;
  left: 0;
  z-index: -1;
  height: 80px;
  width: 100%;
}

.aqi-item {
  flex: 1;
  height: 80px;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: relative;
}

.hour-content {
  position: relative;
  align-items: stretch;
  height: 100px;
  display: flex;
  flex-direction: row;
}

.items {
  align-items: stretch;
  height: 25px;
  display: flex;
  flex-direction: row;
  font-size: 11px;
  color: #666666;
  padding-top: 16px;
}

.hour {
  flex: 1;
  display: flex;
  padding-left: 15px;
  justify-content: flex-start;
}

.tip {
  position: absolute;
  left: 1px;
  width: auto;
  padding: 0 9px 0 7px;
  height: 20px;
  justify-content: center;
  display: flex;
  align-items: center;
  border-top-left-radius: 9px;
  border-top-right-radius: 9px;
  border-bottom-right-radius: 9px;
  color: white;
  font-size: 10px;
  white-space: nowrap;
}

.tip-last {
  position: absolute;
  right: 14.5px;
  width: auto;
  height: 20px;
  padding: 0 9px 0 7.5px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  border-bottom-left-radius: 12px;
  color: white;
  font-size: 10px;
  white-space: nowrap;
  font-family:PingFangSC-Light;
  font-weight:300;
  color:rgba(255,255,255,1);
}
</style>
